import { useQuery } from '@change-corgi/core-react/async';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { getPetitionUpdates } from './getPetitionUpdates';
import type { PetitionUpdatesQueryState, QueryState } from './types';

export function usePetitionUpdatesQuery(queryState: QueryState): PetitionUpdatesQueryState {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();

	const utilityContext = useUtilityContext();

	return useQuery(async () => getPetitionUpdates(id, queryState, utilityContext), [id, utilityContext, queryState]);
}
